<section class="panel-animation" *ngIf="data_level.images">

    <div *ngFor="let image of urls" class="panel-animation-item panel"
         [ngStyle]="{'background-image': 'url(' + image + ')'}">
    </div>
</section>
